import { render, staticRenderFns } from "./VideosShortsSection.vue?vue&type=template&id=79f7a5a2&scoped=true&"
import script from "./VideosShortsSection.vue?vue&type=script&lang=js&"
export * from "./VideosShortsSection.vue?vue&type=script&lang=js&"
import style0 from "./VideosShortsSection.vue?vue&type=style&index=0&id=79f7a5a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f7a5a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
